import React from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import styles from './GovTradesTabs.module.scss';
import type { GovTradesTab } from './getActiveGovTradesTab';

const TABS: { href: string; title: GovTradesTab }[] = [
  { href: '/government-trades', title: 'Overview' },
  { href: '/government-trades/securities', title: 'Securities' },
  { href: '/government-trades/members', title: 'Members' },
];

export const GovTradesTabs = ({ activeTab }: { activeTab: GovTradesTab | null }) => (
  <nav className={styles['tabs']}>
    {TABS.map((t) => (
      <Link
        key={t.href}
        href={t.href}
        className={classNames(styles['tab'], { [styles['active']]: activeTab === t.title })}
      >
        {t.title}
      </Link>
    ))}
  </nav>
);
